<template>
  <div class="main-box main-min-height bgffffff">
    <div class="table-box">
      <div>
        <el-form :model="searchForm" size="mini" label-width="80px" ref="searchForm">
          <el-row :gutter="22">
            <el-col :span="5">
              <el-form-item prop="merchantId" label="商铺名称">
                <el-select clearable v-model="searchForm.merchantId" placeholder="请选择" style="width:100%">
                  <el-option v-for="item in BusinessList" :key="item.id" :label="item.fulName" :value="item.id" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item prop="commodityName" label="商品名称">
                <el-input clearable v-model="searchForm.commodityName" placeholder="-请输入-" style="width:100%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width="20px">
                <el-button type="primary" @click="getInfo(true)">
                  查询
                </el-button>
                <el-button type="primary">
                  导出
                </el-button>
                <el-button type="primary" @click="handleRouter(1)">
                  添加
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-menu :default-active="activeIndex" class="el-menu-demo marginB10" mode="horizontal" @select="handleSelect">
        <el-menu-item index="0">全部商品</el-menu-item>
        <el-menu-item index="2">已下架</el-menu-item>
        <el-menu-item index="1">已上架</el-menu-item>
      </el-menu>
      <el-table :header-cell-style="{background:'#F4F4F5'}" :data="tableData" border style="width: 100%">
        <el-table-column label="ID" prop="id" align="center" width="60"></el-table-column>
        <el-table-column label="商品图片" prop="picturePath" align="center" width="60">
          <template slot-scope="{row}">
            <el-image style="width: 20px; height: 20px" :src="row.picturePath" :preview-src-list="[row.picturePath]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column label="商品名称" prop="commodityName" align="center" min-width="200"></el-table-column>
        <el-table-column label="所属商铺" prop="fullName" align="center" min-width="200"></el-table-column>
        <el-table-column label="创建时间" prop="createTime" align="center" min-width="200"></el-table-column>
        <el-table-column label="库存" prop="stock" align="center" min-width="100"></el-table-column>
        <el-table-column label="价格" prop="money" align="center" min-width="100"></el-table-column>
        <el-table-column label="销量" prop="salesVolume" align="center" min-width="100"></el-table-column>
        <el-table-column label="点击量" prop="hits" align="center" min-width="100"></el-table-column>
        <el-table-column label="上架" prop="hotSale" align="center" min-width="100">
          <template slot-scope="{row}">
            <el-switch v-model="row.hotSale" @change="handleChange(row)" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="2" />
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="{row}">
            <el-button size="mini" @click="handleRouter(2,row.id)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagination class="bgffffff" location='left' :page='page' @getData="getInfo" />
    </div>
  </div>
</template>
<script>
import Pagination from '@/components/pagination/Pagination.vue'
export default {
  name: 'CommodityLIst',
  components: { Pagination },
  beforeRouteEnter: (to, from, next) => {
    next(vm => {
      vm.getInfo()
    })
  },
  data() {
    return {
      searchForm: {
        merchantId: null,
        fullName: null,
      },//查询条件
      tableData: [],//表格参数
      BusinessList: [], //商户列表
      activeIndex: '1',
      page: { //翻页处理
        currentPage: 1,
        pageSize: 50,
        total: 0,
      },
    };
  },
  computed: {},
  mounted() {
    this.getInfo()
    this.getBusiness()
  },
  methods: {
    //获取查询信息
    getInfo(bool) {
      bool ? this.page.currentPage = 1 : ''
      this.$Commodity.pagelist(
        {
          ...this.searchForm,
          state: Number(this.activeIndex),
          page: this.page.currentPage,
          limit: this.page.pageSize
        }
      ).then(({ data }) => {
        if (data.code === 200) {
          this.tableData = data.data
          this.page.total = data.count
        }
      })
    },
    //切换
    handleSelect(e) {
      console.log('切换菜单', e)
      this.activeIndex = e;
      this.getInfo()
    },
    //修改商品是否上下架
    handleChange(e) {
      let { hotSale, id } = e
      this.$Commodity.editCommodityState({
        state: Number(hotSale),
        id
      }).then(({ data }) => {
        if (data.code === 200) {
          this.getInfo()
        }
      })
    },
    //跳转添加页
    handleRouter(type, id) {
      this.$router.push({ path: '/Commodity/AddItem', query: { type, id } })
    },
    //获取商户列表
    getBusiness() {
      this.$MerchantManagement.total().then(({ data }) => {
        if (data.code === 200) {
          this.BusinessList = data.result
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100%;
}
.table {
  width: 100%;
  .table_heder {
    display: flex;
    box-sizing: border-box;
    height: 48px;
    background: #f8f8fe;
    border: 1px solid #eeeeee;
    margin-bottom: 12px;
    > div {
      width: 100px;
      height: 48px;
      line-height: 48px;
      text-align: center;
    }
  }
  .table_content {
    .info_box {
      width: 100%;
      height: 30px;
      background: #f4f4f4;
      display: flex;
      > span {
        width: 250px;
        font-size: 12px;
        line-height: 30px;
        font-family: Source Han Sans CN, Source Han Sans CN-Regular;
        font-weight: 400;
        text-align: center;
        color: #222222;
      }
    }
    .content_box {
      box-sizing: border-box;
      border: 1px solid #eeeeee;
      display: flex;
      > div {
        width: 100px;
        min-height: 48px;
        text-align: center;
      }
    }
  }
}
.flex_shrink {
  flex-shrink: 1;
}
.LR_border {
  border-left: 1px solid #eeeeee;
  border-right: 1px solid #eeeeee;
}
.info_b {
  display: flex;
  box-sizing: border-box;
  height: 88px;
  align-items: center;
  > img {
    width: 55px;
    height: 55px;
  }
  .details_box {
    margin-left: 20px;
    width: 200px;
    display: flex;
    flex-direction: column;
    > span {
      width: 100%;
      text-align: left;
    }
    > div {
      width: 100%;
      display: flex;
      .describe {
        text-align: left;
        width: 100px;
      }
    }
  }
}
.flex_c {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.imgClass {
  height: 30px;
}
</style>
